export default __webpack_public_path__ + "static/MoCuts-500ae6d040c76eb35575fb010adec5a9.webp";